// src/utils/pixel.js
let isPixelInitialized = false;

export const initFacebookPixel = () => {
  if (
    typeof window === 'undefined' ||
    !process.env.REACT_APP_PIXEL_ID ||
    isPixelInitialized
  ) {
    console.warn("⚠️ Pixel initieras inte. ID:", process.env.REACT_APP_PIXEL_ID, "Redan initierad:", isPixelInitialized);
    return;
  }

  console.log("✅ Initierar Facebook Pixel med ID:", process.env.REACT_APP_PIXEL_ID);

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );

  window.fbq('init', process.env.REACT_APP_PIXEL_ID);
  window.fbq('track', 'PageView');
  console.log("📡 PageView skickad till Pixel");
  isPixelInitialized = true;
};


export const trackEvent = (eventName, data = {}) => {
  if (
    typeof window === 'undefined' ||
    !window.fbq ||
    !isPixelInitialized
  ) {
    return;
  }

  try {
    window.fbq('track', eventName, data);
  } catch (err) {
    console.warn(`FB Pixel kunde inte tracka ${eventName}`, err);
  }
};
